import { ReactNode } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { Loader2, Building2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';

interface WorkspaceGuardProps {
  children: ReactNode;
}

export const WorkspaceGuard = ({ children }: WorkspaceGuardProps) => {
  const { isAgency, currentWorkspace, workspaces, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  // MIGRATION CRITICAL: All users MUST have a workspace selected
  // No workspace = redirect to workspace creation/selection page
  if (isAgency && !currentWorkspace) {
    // Allow access to workspaces page and agency pages for workspace selection
    const allowedPaths = ['/workspaces', '/agency/workspaces', '/agency/settings'];
    if (allowedPaths.includes(location.pathname)) {
      return <>{children}</>;
    }
    
    // MANDATORY: Redirect to workspace selection
    return <Navigate to="/workspaces" replace />;
  }

  return <>{children}</>;
};
